import React, { Component } from 'react'
import { Link, hashHistory } from 'react-router'
import Tabs from './tabs'
import {
  PATH_HOTEL_MENU_MANAGE,
  HOTEL_MENU_CREATE_PATH
} from '@components/Hotel/constant'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import { Provider } from 'mobx-react'
import { Button } from 'hljd'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    return (
      <Provider store={this.store}>
        <HeaderView
          header={[
            <Link to={PATH_HOTEL_MENU_MANAGE}>菜单管理</Link>,
            '菜单排序'
          ]}
          title="菜单排序"
          extra={
            <Button
              type="primary"
              onClick={() => hashHistory.push(HOTEL_MENU_CREATE_PATH)}
            >
              发布菜单
            </Button>
          }
        >
          <Tabs />
        </HeaderView>
      </Provider>
    )
  }
}
